import { PanelLeftIcon } from "lucide-react";
import { memo } from "react";
import { CurrentBreadCrumb, ui } from "@harea/component";
import { LanguageMenu } from "./menu/LangMenu";
import { UserProfileDropdown } from "./menu/UserProfileDropdown";

export const AppHeader = memo(function AppHeader({
  onToggleSidebar,
}: {
  onToggleSidebar: () => void;
}) {
  return (
    <header className="flex h-16 shrink-0 border-b border-border bg-white px-4 sticky top-0 z-10">
      <div className="flex items-center gap-4">
        <ui.Button
          variant="ghost"
          size="icon"
          className="!size-9"
          onClick={onToggleSidebar}
          aria-label="Toggle Sidebar"
        >
          <PanelLeftIcon className="size-6" />
          <span className="sr-only">Toggle Sidebar</span>
        </ui.Button>
        <div className="hidden lg:block">
          <CurrentBreadCrumb />
        </div>
      </div>
      <div className="ml-auto flex items-center gap-2">
        <LanguageMenu />
        <UserProfileDropdown />
      </div>
    </header>
  );
});
